// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2GSZQ","noInteraction":"EventWrapper_noInteraction__3raTA","pointerPassthrough":"EventWrapper_pointerPassthrough__iL4nr"};